import { URLS } from '../../../constants';
import apiClient from '../../client';

const dictionaryGrid = {
  getDictionaryGrid: ({
    id,
    heading,
    roleId,
    type,
    assignedTo,
    pagination,
    order,
    name,
    filterValue,
  }: {
    id?: any;
    heading: string;
    roleId: string;
    type: string;
    assignedTo: string;
    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: string;
  }) =>
    apiClient.post(URLS.dictionaryGrid, {
      data: {
        id,
        heading,
        roleId,
        type,
        pagination,
        assignedTo,
        filter: [
          {
            filterKey: 'questionType',
            filterValue: filterValue || '',
          },
        ],
        sorting: {
          order: order || 'DESC',
          fieldName: name || 'createdDate',
        },
      },
    }),
};
export default dictionaryGrid;
